module.exports = __webpack_public_path__ + "img/live.6e26c07d.svg";